export const SET_REPLY_CONTENT = "SET_REPLY_CONTENT";
export const RESET_REPLY_CONTENT = "RESET_REPLY_CONTENT";

export const setReplyContent = (data: any) => {
  return {
    type: SET_REPLY_CONTENT,
    data,
  };
};

export const resetReplyContent = () => {
  return { type: RESET_REPLY_CONTENT };
};
